__webpack_require__.p = "/digitalphotobooth/multi-frame/";